import React, { useContext, useState } from "react"
import "./Screenshots.css"
import { faPlay } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AppContext } from "../../shared/context/AppContext"

// Pick up whichever of the 8 possible screenshots a room has
function load(path) {
  try {
    return require(`./screenshots/${path}`).default
  } catch {
    return null
  }
}

// Slide 0 is the gameplay gif, the rest are screenshots (full1, full2, ...)
function Screenshots({ id, gifName }) {
  const { language } = useContext(AppContext)
  const nl = language === "NL"
  const [active, setActive] = useState(0)

  const slides = [
    {
      full: require(`../../EscaperoomsPage/img/${gifName}`).default,
      thumb: load(`${id}/thumbnail0.jpg`),
    },
  ]
  for (let i = 1; i < 8; i++) {
    const full = load(`${id}/full${i}.jpg`)
    const thumb = load(`${id}/thumbnail${i}.jpg`)
    if (full && thumb) slides.push({ full, thumb })
  }

  return (
    <div className="info-screenshots">
      <div className="big-picture">
        <img
          src={slides[active].full}
          alt={
            active === 0
              ? nl
                ? "Zo ziet het spelen eruit"
                : "What playing looks like"
              : `Screenshot ${active}`
          }
        />
      </div>
      <div className="thumbnails">
        {slides.map((slide, i) => (
          <button
            type="button"
            key={i}
            className={i === active ? "active" : undefined}
            aria-label={i === 0 ? "Video" : `Screenshot ${i}`}
            aria-pressed={i === active}
            onClick={() => setActive(i)}
          >
            <img src={slide.thumb} alt="" />
            {i === 0 && (
              <span className="thumb-play" aria-hidden="true">
                <FontAwesomeIcon icon={faPlay} />
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}

export default Screenshots
